import NamedDto from 'modules/base/dto/NamedDto';

export class MeasurementFieldEditDto extends NamedDto {
	constructor() {
		super();

		/** @type {string} */
		this.type = null;

		/** @type {string} */
		this.category = null;

		/** @type {string} */
		this.uom = null;

		/** @type {string} */
		this.components = null;
	}

	/**
	 * @typedef {Object} _MeasurementFieldEditDtoProps
	 * @property {string} type
	 * @property {string} category
	 * @property {string} uom
	 * @property {string} components
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _MeasurementFieldEditDtoProps} MeasurementFieldEditDtoProps
	 */

	/**
	 *
	 * @param {MeasurementFieldEditDtoProps} props
	 * @returns {MeasurementFieldEditDto}
	 */

	setup(props) {
		super.setup(props);

		this.type = props.type;
		this.category = props.category;
		this.uom = props.uom;
		this.components = props.components;

		return this;
	}
}

export default MeasurementFieldEditDto;